export enum NavItemType {
	Lobby,
	Search,
	Favorites,
	Live,
	Sports,
	World,
	Parlay,
	Promotion,
	PhilippinesSection,
	SportEvent,
}
export type NavItem = {
	sportId?: string;
	href: string;
	routePrefix?: string;
	className: string;
	productName?: string;
	wrapperClassName?: string;
	icon?: string;
	iconType?: 'general' | 'sport' | 'image';
	type: SidebarItemType;
	title: string;
	amount?: number;
	needAuth?: boolean;
	needPromotion?: boolean;
	selected?: boolean;
	subItems?: NavItems;
	useTip?: boolean;
	goldTipText?: string;
	hasStreamer?: boolean;
	isNewWindow?: boolean;
	isRedirectToProduct?: boolean;
	hasLive?: boolean;
	isEnable?: boolean;
	giftIcon?: string;
	menuSource?: 'sports' | 'virtual';
	newTagUntil?: number;
};
export type NavItems = Array<NavItem>;

export type SidebarItemType = 'general' | 'collapsible' | 'flexible' | 'philippines-section' | 'sport-event-section';

export enum GalaxySidebarSwitchTabIndex {
	Live = 0,
	Sports = 1,
}

export enum MarsSidebarSwitchTabIndex {
	Sports = 0,
	Parlay = 1,
}